import React from "../../../../_snowpack/pkg/react.js";
import {CardContainer} from "./styles.js";
const Card = ({suit, value, image}) => {
  return /* @__PURE__ */ React.createElement(CardContainer, null, /* @__PURE__ */ React.createElement("p", null, `${value} ${suit}`), /* @__PURE__ */ React.createElement("img", {
    src: image,
    alt: `${value} of ${suit} playing card.`
  }));
};
export default Card;
